export function isConfigurationInfoEmpty(info) {
    const { infoText, infoImages, infoFiles } = info;
    return !infoText && !infoImages.length && !infoFiles.length;
}
//# sourceMappingURL=isConfigurationInfoEmpty.js.map